import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './style.scss';

export const H1 = (props) => {
  const { children, className } = props;
  const classes = classnames(
    {
      [styles.h1]: true,
    },
    className,
  );
  return <h1 className={classes}>{children}</h1>;
};

H1.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  className: PropTypes.string,
};

H1.defaultProps = {
  className: undefined,
};

export default React.memo(H1);
